require('./bootstrap');
import './libs/trix.js';
require('./vendor/livewire-editorjs/editorjs.js');
import { flare } from "@flareapp/flare-client";

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    flare.light();
}

$('.slider-single').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    infinite: false,
});

var $sliderNav = $('.slider-nav');

var initialslide = $sliderNav.attr("data-initialslide");
var slidestoshow = $sliderNav.attr("data-slidestoshow");

$sliderNav
    .on('init', function (event, slick) {
        $('.slider-nav .slick-slide.slick-current').addClass('is-active');
    })
    .slick({
        slidesToShow: parseInt(slidestoshow),
        dots: false,
        arrows: false,
        focusOnSelect: false,
        infinite: false,

        centerMode: false,
        responsive: [{
            breakpoint: 1100,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        }, {
            breakpoint: 900,
            settings: {
                initialSlide: parseInt(initialslide),
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    });



$sliderNav.on('click', '.slick-slide', function (event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');

    $('.slider-single').slick('slickGoTo', goToSingleSlide);
    $('.slider-nav').slick('slickGoTo', goToSingleSlide);
});

document.addEventListener("trix-file-accept", function (event) {
    console.log('attachments disabled');
    event.preventDefault();
});

// Open all user-added links externally
$(".trix-content a").attr('target', '_blank');


